export default "__VITE_ASSET__64efcea2__"